module.exports = __webpack_public_path__ + "feather.jpg?d8360dc914cdde6a8310653a0318ba55";